import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const DWDM = () => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Compilers and translators, need of translators, structure of compiler: its different phases, compiler construction tools, Lexical analysis: Role of lexical analyzer, Input Buffering, A simple approach to the design of Lexical Analyzers, Specification and recognition of tokens, Finite automata, From regular expressions to automata, and vice versa, minimizing number of states of DFA, A language for specifying Lexical Analyzers, Design and implementation of lexical analyzer.</p>
    </div>,
    <div key="2" className="p-4">
      <p>The role of the parser, Context free grammars, Writing a grammar: Lexical versus Syntactic analysis, Eliminating ambiguity, Elimination of left recursion, Left factoring, Top Down Parsing: Recursive‐Decent parsing, Non‐recursive Predictive parsing, LL(1) grammars, Bottom Up Parsing: Shift Reduce Parsing, Operator precedence parsing, LR Parsing: SLR, LALR and Canonical LR parser, Parser Generators.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Syntax Directed Translation: Syntax directed definitions, Evaluation orders for SDD's, construction of syntax trees, syntax directed translation schemes, implementation of syntax directed translation, Intermediate Code Generation: Kinds of intermediate code: Postfix notation, Parse trees and syntax trees, Three‐address code, quadruples and triples, Semantic Analysis: Types and Declarations, Translation of Expressions, Type checking.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Symbol Table: Symbol tables, its contents, Data Structure for Symbol Table: lists, trees, linked lists, hash tables, Error Detection and Recovery: Errors, lexical phase errors, syntactic phase errors, semantic errors, Error seen by each phase. Code Optimization: The principal sources of optimizations, Loop optimization, Basic blocks and Flow Graphs, DAG representation of basic blocks, Code Generation: Issues in the design of code generation, A simple target machine mode, A Simple Code Generator, Peep‐hole optimization, Register allocation and assignment.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'youtube_playlist',
      label: 'Video Lectures',
      content: null, // Will be replaced in SubjectPage
    },
  ];

  return (
    <SubjectPage
      subjectName="Data Warehousing and Data Mining"
      subjectKey="DWDM"
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'DWDMNotes',
        videos: 'DWDMVideos'
      }}
    />
  );
};

export default DWDM;